import { IconButtonProps } from '@mui/material'
import { KIconButton } from 'components/core/KButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'

export const KDialogCloseButton = ({ sx, ...props }: IconButtonProps) => {
  const theme = useTheme()

  return (
    <KIconButton
      {...props}
      sx={{
        ...sx,
        position: 'absolute',
        right: 24,
        top: 12,
        [theme.breakpoints.down('md')]: {
          top: 8,
        },
      }}
    >
      <CloseIcon />
    </KIconButton>
  )
}
